import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastService, PdfService} from '../../services';
import {PdfDetails} from '../../models/pdf/pdf-details';
import {PageUtil, Timer, TimerUtil} from '../../utils';
import {PDFPageKeys} from '../../enums';
import {ProjectMandateDetails} from '../../models';

@Component({
    selector: 'app-page-pdf-landscape',
    templateUrl: './page-pdf-landscape.component.html',
    styleUrls: ['./page-pdf-landscape.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PagePdfLandscapeComponent implements OnInit, AfterViewChecked, OnDestroy {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private pdfService = inject(PdfService);
    private toastService = inject(ToastService);
    private changeRef = inject(ChangeDetectorRef);


    public uuid: string;
    public PDFPageKeys = PDFPageKeys;
    public pdfDetails: PdfDetails;
    public cssClasses = ['pdf-page-a3-landscape'];
    public mandateDetails: ProjectMandateDetails;
    private timer: Timer;

    public includedPages = new Map([
        [PDFPageKeys.RISKS_OPPORTUNITIES, {
            active: false,
            options: [],
            needPageBreak: () => this.needPageBreak(PDFPageKeys.RISKS_OPPORTUNITIES, 1)
        }],
        [PDFPageKeys.RISKS_OPPORTUNITIES_CLIENT, {
            active: false,
            options: [],
            needPageBreak: () => this.needPageBreak(PDFPageKeys.RISKS_OPPORTUNITIES_CLIENT, 2)
        }]
    ]); // A Map holds the index, so this keeps our ordering in the PagePDF , useful for checking if we need a pagebreak!

    constructor() {
        const route = this.route;
        const pdfService = this.pdfService;

        if (route.snapshot.params.includedPages) {
            route.snapshot.params.includedPages.split('--').forEach((key) => {
                const {pageName, options} = pdfService.getPdfPageWithOptions(key);
                if (route.snapshot.params.includedPages.split('--').includes(PdfService.INCLUDE_PROPOSALS)) {
                    options.push(PdfService.INCLUDE_PROPOSALS);
                }

                if (this.includedPages.has(pageName)) {
                    this.includedPages.get(pageName).active = true;
                    this.includedPages.get(pageName).options = options;
                }
            });
        }

        // When we are on PDF pages, we do not want error tooltips in our PDF
        this.toastService.disableToasts();
        this.uuid = route.snapshot.params.uuid;

        // RISC-600 - Only detect changes once after the data has been collected fully
        this.changeRef.detach();
        this.pdfService.getPdfData(this.uuid).then((pdfDetails) => {
            this.timer.start();
            this.pdfDetails = pdfDetails;
            this.changeRef.detectChanges();
        });
    }

    ngOnInit() {
        PageUtil.scrollToTop();
        PageUtil.addCssClasses(this.cssClasses);

        this.timer = TimerUtil.runCallbackWhenTimerIsIdle(() => {
            this.timer.stop();
            this.pdfService.pageReadyForPdfGeneration();
        }, 1000);
    }

    ngAfterViewChecked() {
        this.timer.tick();
    }

    ngOnDestroy() {
        PageUtil.removeCssClasses(this.cssClasses);
        this.pdfService.pageCleanupAfterPdfGeneration();
    }

    pageIncluded(key) {
        return this.includedPages.get(key).active;
    }

    pageOptions(key) {
        return this.includedPages.get(key).options;
    }

    needPageBreak(key, index?: number) {
        if (!index) {
            return this.includedPages.get(key).needPageBreak();
        } else {
            const pageKeys = this.includedPages.keys();
            for (let i = 0; i < index; i++) {
                const currentKey = pageKeys.next();
                if (currentKey && this.includedPages.get(currentKey.value).active) {
                    return true;
                }
            }
            return false;
        }
    }

}
